// extracted by mini-css-extract-plugin
export default {"actions":"WinterNotification_actions__FjaYE","btn":"WinterNotification_btn__J7TzG"};